import { c as _c } from "react/compiler-runtime";
import { BrandIcon } from '@cc-shopping/ui/primitives/BrandIcon';
import type { BrandIconName } from '@cc-shopping/ui/primitives/BrandIcon/types';
import { palette } from '@cc-shopping/ui/theme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { ExpandCardClient } from './ExpandCardClient';
type ExpandCardProps = StructuredContentDocumentWithRenderer<{
  icon?: BrandIconName;
  title1?: string;
  title2?: string;
}>;
export function ExpandCard(t0) {
  const $ = _c(30);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props) {
    t1 = props ?? {};
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    children,
    icon,
    title1,
    title2
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      flexDirection: "row",
      gap: 2,
      listStyle: "none",
      "::-webkit-details-marker": {
        display: "none"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== icon) {
    t3 = icon && <BrandIcon name={icon} size={24} svgStyles={{
      width: {
        xs: "24px",
        lg: "32px"
      },
      height: {
        xs: "24px",
        lg: "32px"
      },
      fill: "neutral.darker"
    }} />;
    $[3] = icon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      gap: 2,
      alignItems: "center",
      flex: 1,
      justifyContent: {
        xs: "space-between",
        lg: "center"
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "greens.main",
      fontSize: {
        xs: "20px",
        lg: "26px"
      },
      order: {
        xs: 2,
        lg: 1
      },
      fontWeight: 500
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== title1) {
    t6 = <Typography sx={t5}>{title1}</Typography>;
    $[7] = title1;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      color: "neutral.darker",
      fontSize: "16px",
      fontWeight: 500,
      order: {
        xs: 1,
        lg: 2
      }
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== title2) {
    t8 = <Typography sx={t7}>{title2}</Typography>;
    $[10] = title2;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <Box sx={t4}>{t6}{t8}</Box>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "flex",
      justifyContent: "flex-end"
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "24px",
      height: "24px",
      backgroundColor: "neutral.lightest",
      borderRadius: "100%",
      transition: "transform 0.3s ease",
      "[open] > summary &": {
        transform: "rotate(180deg)"
      }
    };
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Box sx={t10}><Box component="span" sx={t11}><span className="mask-icon mask-icon-expand-more" style={{
          width: "24px",
          height: "24px",
          backgroundColor: palette.neutral.light
        }} /></Box></Box>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t3 || $[19] !== t9) {
    t13 = <Box component="summary" sx={t2}>{t3}{t9}{t12}</Box>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      color: "neutral.darker",
      fontSize: "13px",
      lineHeight: "150%",
      py: 1.5,
      "& > *:last-child": {
        mb: 0
      }
    };
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== children) {
    t15 = renderStructuredContent(children);
    $[22] = children;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t15) {
    t16 = <Typography component="div" sx={t14}>{t15}</Typography>;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t13 || $[27] !== t16 || $[28] !== title2) {
    t17 = <ExpandCardClient title2={title2}>{t13}{t16}</ExpandCardClient>;
    $[26] = t13;
    $[27] = t16;
    $[28] = title2;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
}